import { useNavigate } from 'react-router-dom'

const styles = `
body{
    margin:0;
    font-family:'Open Sans',sans-serif;
    background:#f7f8fc;
}

.destination-hero{
    background:#1a2e6e;
    color:white;
    padding:80px 20px;
}

.destination-container{
    max-width:1100px;
    margin:auto;
}

.destination-hero h1{
    font-size:46px;
    margin-bottom:15px;
    font-family:'Nunito',sans-serif;
}

.destination-hero p{
    font-size:18px;
    max-width:720px;
    opacity:.95;
    line-height:1.8;
}

.destination-content{
    max-width:1000px;
    margin:50px auto;
    background:white;
    border-radius:16px;
    padding:45px;
    box-shadow:0 10px 30px rgba(0,0,0,.08);
}

.destination-content h2{
    color:#1a2e6e;
    margin-top:40px;
    margin-bottom:20px;
    font-size:30px;
}

.destination-content h3{
    color:#1a2e6e;
    margin-bottom:15px;
}

.destination-content p{
    line-height:1.9;
    color:#555;
}

.destination-content li{
    margin-bottom:15px;
    line-height:1.8;
}

.highlight{
    background:#eef8f2;
    border-left:6px solid #39b36a;
    padding:25px;
    border-radius:12px;
    margin-top:35px;
}

.process{
    background:#f5f7fb;
    border:1px solid #d8dfef;
    padding:20px;
    border-radius:12px;
    text-align:center;
    font-weight:700;
    color:#1a2e6e;
    margin:25px 0;
}

.back-btn{
    background:#f5a623;
    color:white;
    border:none;
    padding:12px 24px;
    border-radius:8px;
    cursor:pointer;
    font-weight:700;
    margin-bottom:30px;
}

.back-btn:hover{
    opacity:.9;
}

@media(max-width:768px){

.destination-hero{
    padding:55px 20px;
}

.destination-hero h1{
    font-size:34px;
}

.destination-content{
    margin:20px;
    padding:25px;
}

}
`

export default function EuropeDestination() {
  const navigate = useNavigate()

  return (
    <>
      <style>{styles}</style>

      <section className="destination-hero">
        <div className="destination-container">
          <button className="back-btn" onClick={() => navigate('/', { state: { scrollTo: 'study-destinations' } })}>
            ← Back
          </button>

          <h1>🇪🇺 Europe (Schengen Area)</h1>

          <p>
            From zero-tuition universities in Germany to world-renowned innovation hubs in Finland, Hungary, and Poland,
            <strong> Europe</strong> offers world-class qualifications coupled with the freedom to explore an entire continent.
          </p>
        </div>
      </section>

      <div className="destination-content">
        <h2>✨ Why Choose Europe?</h2>

        <ul>
          <li>
            <strong>Affordable to Zero Tuition Fees:</strong> Many public universities across Schengen countries offer tuition-free or low-cost education for international
            students.
          </li>

          <li>
            <strong>29 Countries, One Visa:</strong> A Schengen student visa allows you to travel freely across 29 European countries without separate visas.
          </li>

          <li>
            <strong>Excellent Post-Study Work Opportunities:</strong> Many European countries allow graduates to stay for 1–2 years after graduation to find employment and build
            their careers.
          </li>

          <li>
            <strong>Globally Recognized Education:</strong> Standardized ECTS credit systems and internationally respected universities make transferring and pursuing higher
            education easier.
          </li>
        </ul>

        <h2>📋 Essential Documents</h2>

        <ul>
          <li>
            <strong>Passport:</strong> Valid passport with sufficient validity according to your destination country's requirements.
          </li>

          <li>
            <strong>Academic Certificates & Transcripts:</strong> Ministry-attested educational certificates and transcripts.
          </li>

          <li>
            <strong>Language Proficiency:</strong> IELTS, PTE, or Medium of Instruction (MOI) certificate depending on university requirements.
          </li>

          <li>
            <strong>Financial Proof:</strong> Blocked Account confirmation (where applicable) or sufficient bank solvency documents.
          </li>

          <li>
            <strong>Europass CV & Cover Letter:</strong> Professionally formatted academic CV and motivation letter.
          </li>

          <li>
            <strong>Health & Travel Insurance:</strong> Insurance coverage valid throughout the Schengen Area.
          </li>
        </ul>

        <h2>🚀 Application & Visa Process</h2>

        <div className="process">University Acceptance → Financial Proof / Blocked Account → Embassy Appointment → Visa Approval → Fly to Europe 🇪🇺</div>

        <ol>
          <li>
            <strong>Apply to Universities:</strong> Submit applications through the respective university admission portals.
          </li>

          <li>
            <strong>Arrange Financial Proof:</strong> Open a blocked account (if required) or prepare sponsor/bank solvency documents.
          </li>

          <li>
            <strong>Embassy Appointment:</strong> Complete biometrics, document verification, and interview at the embassy.
          </li>

          <li>
            <strong>Travel & Registration:</strong> Receive your student visa, travel to your destination country, and complete local residence registration.
          </li>
        </ol>

        <div className="highlight">
          <h3>🤝 How StudyBuddy Helps</h3>

          <ul>
            <li>
              <strong>Country & University Selection:</strong> We help you choose the best European country and university based on your budget, profile, and career goals.
            </li>

            <li>
              <strong>Document Attestation:</strong> Complete guidance for ministry attestations and educational document preparation.
            </li>

            <li>
              <strong>SOP & Europass CV:</strong> We prepare professional motivation letters and Europass CVs that meet European admission standards.
            </li>

            <li>
              <strong>Blocked Account Assistance:</strong> Guidance for opening blocked accounts and preparing financial documents correctly.
            </li>

            <li>
              <strong>Visa Support:</strong> End-to-end assistance for embassy appointments, interviews, and visa documentation.
            </li>

            <li>
              <strong>Pre-Departure Guidance:</strong> Accommodation advice, travel planning, insurance guidance, and settlement support before you fly.
            </li>
          </ul>
        </div>
      </div>
    </>
  )
}
